import React, { Component } from 'react'

import logo from './assets/50th-logo--color.svg'
import background from './assets/50th-logo.svg'
import foregroundBottom from './assets/foreground--bottom.svg'
import foregroundTop from './assets/foreground--top.svg'


import TimelineCard from './components/TimelineCard.jsx'
import TIMELINE_DATA from './data/timeline.js'


import './App.scss';

class App extends Component {
    render() {
        return (
            <div className="App__">
                <div className='_Background__'>
                    <img
                        className='WC50thLogo'
                        src={background}
                        alt='Wilson Center 50th Anniversary logo'
                    />
                    <span className='TimelineLine' />
                </div>

                <div className='_Timeline__'>
                    {
                        TIMELINE_DATA.map(item => {
                            return (
                                <TimelineCard
                                    date        = {item.date}
                                    headline    = {item.headline}
                                    content     = {item.content}
                                    link        = {item.link}
                                    linkLabel   = {item.linkLabel}
                                    image       = {item.image}
                                />
                            )
                        })
                    }
                </div>

                <div className='_Foreground__'>
                    <img className='ForegroundBottom' src={foregroundBottom} />
                    <img className='ForegroundTop' src={foregroundTop} />
                    <a href="https://www.wilsoncenter.org" target='_blank'>
                        <img className='Branding' src={logo} alt='50th anniversary logo' />
                    </a>
                    <span className='Title'>
                        Wilson Center celebrates 50 years,<br />1968-2018
                    </span>
                </div>


            </div>
        );
    }
}

export default App;
